function EmbedError(message, accountType, accountId) {
  this.name = 'Embed Mode Error';
  this.message = message || 'Unexpected Embed Mode Error';
  this.accountType = accountType;
  this.accountId = accountId;

  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
  this.stack = new Error().stack;
}

EmbedError.prototype = Object.create(Error.prototype);
EmbedError.prototype.constructor = EmbedError;

export default EmbedError;
